const puzzle = {
  id: "FiwnDiTdubEIy0Ky2gQk",
  name: "Stepping Into Surreal",
  rebuses: [
    {
      style: {},
      id: "8bc5f485-fab1-40ea-a0b3-d26ce8cd9485",
      solutionInfo: {
        type: "text",
        solvedText: "Down",
        possibleSolutions: [
          {
            value: "Down",
            id: "d425b529-d0eb-405c-b988-8c7dd1ea880f",
          },
          {
            value: "Kate Downton",
            id: "dce2cf8e-ce5c-4b24-81a5-a8b8eee40afc",
          },
          {
            id: "ece691a8-e63e-461b-b66a-0e4f456986bb",
            value: "Downton",
          },
        ],
      },
      clues: [
        {
          helperText: "Vanity fair, 100th anniversary",
          subtext: "",
          clueValues: [
            {
              value: "n4pMbiGL.png",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "4a666386-0296-4743-884c-2fa847f66ab4",
            },
          ],
          id: "76ecd135-8901-451f-89ba-8927c8b3cbe9",
          clueGroup: 0,
          dependsOn: [],
          style: {
            width: "calc(25% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
        },
        {
          style: {
            width: "calc(5% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "➜",
              subtext: "",
              id: "208195d1-5396-4b08-9d47-9bada155d528",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          clueGroup: 0,
          dependsOn: [],
          id: "f76ba087-8565-4544-ab24-497d2971c6ef",
          helperText: "",
          subtext: "",
        },
        {
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          helperText: "A member of a royal family.",
          clueGroup: 0,
          clueValues: [
            {
              type: "image",
              id: "140da9b3-b6ef-41bd-9330-1b1200adbe8f",
              subtext: "",
              value: "dLYdBDzI.png",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          subtext: "",
          style: {
            width: "calc(25% - 10px)",
          },
          dependsOn: [],
          id: "425432ca-549e-40b0-8161-4b9424b80f46",
        },
        {
          dependsOn: [],
          id: "eeaadfd0-f0ad-464a-8ad2-c7eb3bd96dc5",
          clueValues: [
            {
              subtext: "",
              value: "➜",
              type: "text",
              id: "db8f3b09-3819-4382-af2b-2a2c2b3deb31",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          subtext: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 0,
          style: {
            width: "calc(5% - 10px)",
          },
          helperText: "",
        },
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "696dc4bc-848f-4174-be53-c0bb4b790793",
              subtext: "",
              value: "1xJbEFss.png",
              type: "image",
            },
          ],
          id: "6f07803e-c459-425d-8502-4ffc00730c6a",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 0,
          style: {
            width: "calc(25% - 10px)",
          },
          subtext: "",
          helperText:
            "These two women have directions in them. Find the third direction.",
        },
      ],
    },
    {
      clues: [
        {
          clueValues: [
            {
              id: "30f1855c-6c0a-469c-a461-b186482ff9c3",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Get Hard",
              type: "image",
              value: "S5FZTPCw.png",
            },
          ],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Kevin Hart",
                id: "bnfg-3404-fsdqw-8cae-ee",
              },
            ],
            solvedText: "Kevin Hart",
            type: "text",
          },
          dependsOn: [],
          clueGroup: 0,
          helperText:
            "He climbs into his own chair. He climbs out of his own bathtub.",
          style: {
            width: "calc(50% - 10px)",
          },
          id: "a4e58f00-410e-4d55-a7b7-0789090dd200",
        },
        {
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "12a30856-db7c-43b1-b281-ea291debbd99",
              subtext: "He's just not that into you",
              type: "image",
              value: "iSo7YcAE.png",
            },
          ],
          subtext: "",
          id: "8b16932e-d444-490f-874c-989f64538e17",
          solutionInfo: {
            solvedText: "Ginnifer Goodwin",
            type: "text",
            possibleSolutions: [
              {
                value: "Ginnifer Goodwin",
                id: "7-3404-765-234-1",
              },
            ],
          },
          helperText: "",
          style: {
            width: "calc(50% - 10px)",
          },
        },
        {
          dependsOn: [],
          clueValues: [
            {
              value: "qwM9ovJo.png",
              style: {
                width: "calc(50% - 10px)",
              },
              subtext: "",
              type: "image",
              id: "5610e5d0-3413-4185-b7c9-96cb0cbcf0fa",
            },
            {
              style: {
                width: "calc(50% - 10px)",
              },
              subtext: "",
              id: "4b375170-8391-44fd-996b-cbc9c333ca6d",
              value: "LRTFGSJO.png",
              type: "image",
            },
          ],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          helperText:
            "Both actors are also voice actors. Both actors played the role of an animal. Which one?",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "3db8193f-bc1f-430f-8934-207f9f2f86c3",
          clueGroup: 0,
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Rabbit",
        type: "text",
        possibleSolutions: [
          {
            id: "2e54bf2a-6b97-43ed-8f9b-eeab9234bc7c",
            value: "Rabbit",
          },
          {
            id: "1c4c1085-f496-40f3-846c-83b314a88667",
            value: "Bunny",
          },
        ],
      },
      id: "8720c364-e2d7-4f63-bce1-42837cd04e39",
    },
    {
      clues: [
        {
          helperText: "It took him a long time.",
          subtext: "",
          clueGroup: 1,
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          style: {
            width: "calc(33% - 10px)",
          },
          id: "1e328936-0211-4060-aea0-c2c10c7db4f4",
          dependsOn: [],
          clueValues: [
            {
              subtext: "made it",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Andy Dufresne",
              type: "text",
              id: "cb1f23ed-2f37-42ad-9a78-1c6a4dee5e54",
            },
          ],
        },
        {
          clueGroup: 2,
          dependsOn: [],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          id: "10c1d3f4-744b-4f64-8ffd-875cbfdad023",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              type: "text",
              subtext: "climbed it",
              value: "The Dark Knight",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "1112c885-68c4-4489-bf5c-edfc8a1350db",
            },
          ],
          helperText: '"Deshi Basara"',
        },
        {
          clueGroup: 3,
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              type: "text",
              id: "dabb3799-d8b3-43c7-aa28-b8503ef21fec",
              subtext: "entered it",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Joseph Cooper",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          subtext: "",
          id: "bf38cb35-87f1-4de7-b077-dd109e70fc05",
          dependsOn: [],
          helperText: "Where was he when he was her ghost?",
        },
      ],
      solutionInfo: {
        solvedText: "Hole",
        possibleSolutions: [
          {
            value: "Hole",
            id: "db5eb187-6157-406c-8c3c-fde84e592177",
          },
        ],
        type: "text",
      },
      style: {},
      id: "9af52ad5-82da-4ed0-8943-ee3a1f72c8f7",
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            id: "6add2f39-1a73-4703-8c2b-fd35aabd3e72",
            value: "Alice in Wonderland",
          },
          {
            id: "6add2f39-1a73-4703-8aab-fd35aabd3e72",
            value: "Alice in the Wonderland",
          },
          {
            id: "062190a0-07ec-47c3-81b9-4c4965ec3530",
            value: "Alice's Adventures in Wonderland",
          },
          {
            id: "c40da5a4-1677-4ef0-87cb-6e5e05faacf3",
            value: "Alice",
          },
        ],
        solvedText: "Alice in Wonderland",
        type: "text",
      },
      clues: [
        {
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          helperText: "",
          subtext: "",
          clueGroup: 0,
          id: "8d162e5b-55d0-42ce-8258-d50c1e92b821",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "slang origin",
              value: "Down the rabbit hole",
              type: "text",
              id: "6dfe4e28-b2a8-4f27-8798-257f733be74b",
            },
          ],
        },
      ],
      id: "a72319fa-28c5-4e46-95c4-bfbe6868a272",
      style: {},
    },
  ],
};
export default puzzle;
